/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * DATE : the date
 *   * LOGIN : the login
 *   * LAST_NAME : the last name
 *   * FIRST_NAME : the first name
 *   * PROVIDER : the provider
 */
export enum UserSortFieldName {
  DATE = 'DATE',
  LOGIN = 'LOGIN',
  LAST_NAME = 'LAST_NAME',
  FIRST_NAME = 'FIRST_NAME',
  SUBSCRIPTION = 'SUBSCRIPTION',
  PROVIDER = 'PROVIDER'
}
